import { ReviewUserModel } from '@app/models/review-user.model';

export class ReviewModel {
    public note: number;
    public title: string;
    public shortMessage: string;
    public message: string;
    public created_at: Date;
    public user: ReviewUserModel;
    public recommanded: boolean = false;
    public syndication: {
        image: string;
        name: string;
    } = null;
    public pros: string = null;
    public cons: string = null;
    public recommendedFor: string;
}
